import router from "src/router";
import AppConvertService from '@core/services/utils/appConvertService';

import appConsoleService from '@core/services/utils/appConsoleService';
import AppEnvService from '@core/services/utils/appEnvService';
import AppNotificationService from '@core/services/utils/appNotificationService';

class AppNavigationService {

  /**
   * Options :
   * String : navigation depends on a path
   * Json : navigation depends on name and params
   * @param options
   * @returns {Promise<void>}
   */
  async push(options) {
    try {
      await router.push(options)
      appConsoleService.info('navigationService','Navigation with ' + JSON.stringify(options))
    } catch(error) {
      console.error(error)
    }
  }

  async pushTo(path) {
    await this.push(path);
  }

  async goBack() {
    await router.back()
  }

  async goToHome() {
    await this.push("/")
  }

  async goToLogin() {
    await this.push("/login")
  }

  async goTo401() {
    await this.push({
      name: "error-401"
    });
  }

  /**
   * Bascule en mode maintenance : route vers /no-landing, qui affiche
   * « Maintenance en cours » tant que appEnvStore.status === 'error'.
   * `replace` pour ne pas piéger le bouton retour sur la page de panne.
   */
  async goToMaintenance() {
    try {
      if (router.currentRoute.value?.name === 'no-landing') return;
      await router.replace({ name: 'no-landing' });
    } catch (error) {
      console.error(error);
    }
  }

  async goToKanban() {
    await this.push({
      name: "rms-kanban",
      params: {replace: true},
    });
  }

  async goToAppProfil(user) {
    await this.push({
      name: "app-user-detail",
      params: {userId: user.id, replace: true},
    });
  }

  async goToRmsProfil(user) {
    await this.push({
      name: "rms-user-detail",
      params: {userId: user.id, replace: true},
    });
  }

  async goToTalProfil(user) {
    await this.push({
      name: "tal-user-detail",
      params: {userId: user.id, replace: true},
    });
  }

  async goToSosProfil(user) {
    await this.push({
      name: "sos-user-detail",
      params: {userId: user.id, replace: true},
    });
  }

  async goToTicket(ticket) {
    await this.push({
      name: "rms-ticket-detail",
      params: {ticketId: ticket.id, replace: true},
    });
  }

  async goToTicketAdd(productId) {
    await this.push({
      name: "rms-ticket-add",
      params: {productId: productId, replace: true},
    });
  }


  /**
   * Profil détaillé de l'utilisateur connecté, selon le produit déployé (APP_CODE) :
   * chaque module déclare une route statique `meta.myProfile` (rms → rmsUserDetail,
   * tal → talUserDetail, sos → sosPersonal, modular → modUserDetail, pronova →
   * appUserDetail), indépendante des droits sur le menu « Utilisateurs ».
   * Repli : la fiche générique app-user-detail si elle est routée.
   */
  async goToPersonalProfil(userId) {
    const appCode = (AppEnvService.getAppCode() || window.environment?.APP_CODE || '').toLowerCase();
    const route = router.getRoutes().find(r => r.meta?.myProfile && r.meta.appCodes?.includes(appCode));
    const name = route?.name || (router.hasRoute('app-user-detail') ? 'app-user-detail' : null);
    if (!name) {
      appConsoleService.warn('navigationService', `Aucune page de profil pour APP_CODE=${appCode}`);
      return;
    }
    await this.push({ name, params: { userId } });
  }

  openExternalLink(url) {
    window.open(url, "_blank");
  }

}

export default new AppNavigationService()
